export default {
//  只能是英文
  yingwen: /^[a-zA-Z]+$/,
//  英文和空格
  yingwenkg: /^[a-zA-Z\s]+$/,
//  中文
  zhongwen: /^[\u4E00-\u9FA5]+$/,
//  正整数和小数点
  zhengshuxsd: /^\d+(\.\d{1,2})?$/,
//  身份证
  shenfenzheng: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
//  军官证或士兵证
  junguanzheng: /^(P\d{7})|(G\d{8})$/,
//  固定电话
  gudingphone: /^(0[0-9]{2,3}\-)([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/,
//  手机号码
  //phone: /^1[34578]\d{9}$/,
    phone: /^[1][0-9]{10}$/,
//  邮政编码
  youzheng: /^[0-9][0-9]{5}$/,
//  银行账号
  bankcode: /^([1-9]{1})(\d{14}|\d{15}|\d{18})$/,
    // 正整数
    zhengshu: /^-?[1-9]+[0-9]*$/,    // 8-16位
  eightSixteen:/^.{8,16}$/,
  // 必须包含数字、字母、特殊字符 8-16位
  password:/(?=.*[a-z_])(?=.*\d)(?=.*[^a-z0-9_])[\S]{8,16}/i
};



// WEBPACK FOOTER //
// ./src/static/js/validate/regular.js